export default __webpack_public_path__ + "static/media/partenariat.de7dcd02.png";